
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/mortgage",
      function () {
        return require("private-next-pages/products/mortgage/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/mortgage"])
      });
    }
  